<div class="p-fluid">
  <p class="font-bold text-lg">Вы действительно хотите удалить компанию?</p>
  <p class="mt-2 text-gray-400">
    Выберите компанию, к которому перейдут все связанные объекты, в том числе и платежные аккаунты удаленной компании.
  </p>

  <div class="field mt-3">
    <label class="font-medium required-field">Компания</label>
    <crm-company-single-select
      [(selectedCompany)]="company"
      [excludeIds]="previousCompanyIds"
      appendTo="body"></crm-company-single-select>
  </div>
</div>

<div class="flex justify-content-end gap-3 mt-5">
  <crm-button
    icon="pi pi-times"
    label="Отмена"
    styleClass="p-button-danger p-button-outlined"
    (onClick)="ref?.close()"></crm-button>

  <crm-button
    icon="pi pi-check"
    label="Удалить"
    styleClass="p-button-success"
    [disabled]="!company"
    (onClick)="ref?.close(company)"></crm-button>
</div>
